@use 'sass:math';
@use '../../../scss/utility';

@mixin wb-grid-styles-for-mq($mq) {
  // to reset the grid flow if a start-col was used before
  :host([start-col-#{$mq}='auto']) {
    grid-column-start: auto;
  }

  @for $i from 1 through utility.$wb-grid-column-amount {
    :host([start-col-#{$mq}='#{$i}']) {
      grid-column-start: $i;
    }

    :host([#{$mq}='hide']) {
      display: none; // to have a collapsing grid item if needed for offset
    }

    :host([#{$mq}='#{$i}']) {
      display: unset; // to reset the display to the inherited value of `display: grid;`
      grid-column-end: span $i;
    }
  }
}

:host {
  overflow-x: auto;
}

:host([allow-overflow-x]) {
  overflow-x: visible;
}

@each $mq in map-keys(utility.$wb-breakpoints) {
  @if ($mq == mq1) {
    @include wb-grid-styles-for-mq($mq);
  } @else {
    @include utility.breakpoint-from($mq) {
      @include wb-grid-styles-for-mq($mq);
    }
  }
}
